import { atom, useAtomValue } from 'jotai'
import { OverviewStorage } from './interface'
import { allProductsDataFactory } from 'services/query-v2/products/products'
import { AnyWritableAtom } from 'components/scope-provider'
import { loadable } from 'jotai/utils'

const dailyStatRequestAtoms = allProductsDataFactory()
const loadableIndexDailyStatsAtom = loadable(dailyStatRequestAtoms.response)

const productOverviewAtom = atom(async (get) => {
  const loadableAtom = await get(loadableIndexDailyStatsAtom)
  if (loadableAtom.state === 'hasError') {
    throw loadableAtom.error
  }
  if (loadableAtom.state === 'hasData') {
    return loadableAtom.data
  }
  return []
})

export const getOverviewStorage = (): OverviewStorage => {
  const response = {
    products: useAtomValue(productOverviewAtom),
  }
  return response
}

export const createOverviewStorage = () => {
  const response: [AnyWritableAtom, unknown][] = []
  return response
}
